import { Component, OnDestroy, OnInit } from '@angular/core';
import { control, olx } from 'openlayers';
import { MapComponent } from '../map.component';

@Component({
  selector: 'aol-control-rotate',
  template: `<ng-content></ng-content>`
})
export class ControlRotateComponent implements OnInit, OnDestroy {
  instance: control.Rotate;

  constructor(private map: MapComponent) {}

  ngOnInit() {
    this.instance = new control.Rotate(this as unknown as olx.control.RotateOptions);
    this.map.instance.addControl(this.instance);
  }

  ngOnDestroy() {
    this.map.instance.removeControl(this.instance);
  }
}
